<template>
  <div class="vm-characteristic">
      <section class="vm-title-border">


           <div class="vm-title-headline">
        <span>Java项目</span>
        <span>学完之后你可以做什么?</span>
      </div>
      <div class="vm-title-subhead">Java成为网站和App的公认后台服务器首选</div>
          <div class="vm-title-subhead">更是经久不衰、就业机会众多的根本原因</div>
    
    
    </section>
    <section class="vm-characteristic-cont pd20">
        <img src="../../../assets/img/k_sj.png">
         <div class="vm-more theme_jb bgff"  @click="goMore()">做Java职业生涯更多规划&nbsp; ></div>
    </section>
  </div>
</template>

<script>
export default {

   data(){
    return{
        city: localStorage.getItem("city")
    }
  },
  methods:{
    goMore(){
        if (this.city == '2') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/9002684/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '5') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10151581/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '1') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10159302/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '3') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10160432/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '4') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10179872/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else if (this.city == '6') {
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/10151577/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      } else{
        let _53code = document.createElement("script");
        _53code.src = "https://tb.53kf.com/code/code/9002684/1";
        let s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(_53code, s);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/comm.css");

@import url("../../../assets/css/title.css");
.vm-characteristic-cont img{
    width: 100%;
}

</style>